import { ApplicationState } from '@store/types'

type EnderecoState = ApplicationState['refinanciamento']['endereco']
type DadosBancariosState = ApplicationState['refinanciamento']['dadosBancarios']
type EnderecoRequiredField =
  | 'cep'
  | 'tipoLogradouro'
  | 'logradouro'
  | 'numero'
  | 'bairro'
  | 'uf'
  | 'cidade'
type DadosBancariosRequiredField =
  | 'bancoSelecionado'
  | 'tipoContaSelecionado'
  | 'agencia'
  | 'contaDadosBancarios'
  | 'digito'
type EnderecoData = Pick<EnderecoState, EnderecoRequiredField>
type DadosBancariosData = Pick<DadosBancariosState, DadosBancariosRequiredField>

const ENDERECO_REQUIRED_FIELDS: readonly EnderecoRequiredField[] = [
  'cep',
  'tipoLogradouro',
  'logradouro',
  'numero',
  'bairro',
  'uf',
  'cidade',
]

const DADOS_BANCARIOS_REQUIRED_FIELDS: readonly DadosBancariosRequiredField[] = [
  'bancoSelecionado',
  'tipoContaSelecionado',
  'agencia',
  'contaDadosBancarios',
  'digito',
]

export function hasCompleteEndereco(endereco: EnderecoData): boolean {
  return ENDERECO_REQUIRED_FIELDS.every((field) => Boolean(endereco[field]))
}

export function hasCompleteDadosBancarios(dadosBancarios: DadosBancariosData): boolean {
  return DADOS_BANCARIOS_REQUIRED_FIELDS.every((field) => Boolean(dadosBancarios[field]))
}
